import { Tooltip } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as ClipboardListIcon } from '../../assets/icons/SVG/clipboard-list.svg';

export interface DetailsTableIconLinkProps {
    to: string;
    /** Shown on hover and for accessibility */
    tooltip?: string;
}

/**
 * Clipboard icon + link used for row "Details" columns across entity tables.
 */
const DetailsTableIconLink: React.FC<DetailsTableIconLinkProps> = ({
    to,
    tooltip = 'Details',
}) => (
    <Tooltip title={tooltip} mouseEnterDelay={0}>
        <span className="table-details-icon-tooltip-wrap">
            <Link
                to={to}
                className="table-details-icon-link"
                aria-label={tooltip}
            >
                <ClipboardListIcon className="table-action-svg-icon" aria-hidden />
            </Link>
        </span>
    </Tooltip>
);

export default DetailsTableIconLink;
